import {resourcesTypes} from '../types';
import {ResourcesActionType, ResourceType} from '../../../types/resourcesTypes';

const initialState = {
  resources: null as ResourceType | null,
};

const resourcesReducer = (state = initialState, action: ResourcesActionType) => {
  switch (action.type) {
    case resourcesTypes.GET_RESOURCES:
      return {
        ...state,
        resources: action.resources ?? null,
      };
    default:
      return state;
  }
};

export default resourcesReducer;
